import { yup } from '@framework/validation/initYup.ts';
import { fromPairs } from 'lodash';
import { type IAdvancedSelectWidget } from '../IAdvancedSelectWidget.ts';
import { getDatatypeColumnSchema } from '../utils/getDatatypeColumnSchema.ts';
import { getUniqueOptionValue } from '../utils/geUniqueOptionValue.ts';

/**
 * Rappresenta il valore all'interno dei FormValues del widget AdvancedSelect
 */
export interface IWidgetAdvancedOptionValue {
  [columnId: string]: any;
}

/**
 * Schema per un singolo oggetto con tutte le colonne
 */
export function createAdvancedSelectValueSchema(widget: IAdvancedSelectWidget) {
  const optionsMap = new Map<string, IWidgetAdvancedOptionValue>();
  for (const option of widget.options) {
    const optionId = getUniqueOptionValue(widget, option);
    optionsMap.set(optionId, option.values ?? {});
  }

  return yup
    .object<IWidgetAdvancedOptionValue>(
      fromPairs([
        ...widget.columns.map(column => [
          column.id,
          getDatatypeColumnSchema(column.type),
        ]),
      ]),
    )
    .noUnknown();
}
